import { CustomCheckoutShippingStateType } from "@iewcasia/Store/State/CheckoutShipping/CheckoutShippingState";
import createTypedReducer from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

const initialState: CustomCheckoutShippingStateType = {
    cartLines: [],
    redirectToCartPage: false,
    // IEIXOP-6930: carrier address error modal on Checkout Shipping
    isCarrierAddressErrorModalOpen: false,
};

export const customCheckoutShippingReducer = createTypedReducer(initialState, {
    "Custom/CheckoutShipping/CartLines": (
        draft: Draft<CustomCheckoutShippingStateType>,
        cartLines: { cartLines: [] },
    ) => {
        return {
            ...draft,
            ...cartLines,
        };
    },
    "Custom/CheckoutShipping/RedirectToCartPage": (
        draft: Draft<CustomCheckoutShippingStateType>,
        redirectToCartPage: { redirectToCartPage: boolean },
    ) => {
        return {
            ...draft,
            ...redirectToCartPage,
        };
    },

    // IEIXOP-6930
    "Custom/CheckoutShipping/SetCarrierAddressErrorModal": (
        draft: Draft<CustomCheckoutShippingStateType>,
        action: { isCarrierAddressErrorModalOpen: boolean },
    ) => {
        return {
            ...draft,
            isCarrierAddressErrorModalOpen: action.isCarrierAddressErrorModalOpen,
        };
    },
});

